import { IUnit } from '@numeo/types-core'
import { FormControl, FormLabel, Input, Select, Stack, Option } from '@mui/joy'
import React from 'react'

interface WeightFieldGroupProps {
    weight: IUnit
    onChange: (weight: IUnit) => void
    label?: string
    disabled?: boolean
}

export const WeightFieldGroup: React.FC<WeightFieldGroupProps> = ({ weight, onChange, label = 'Weight', disabled = false }) => {
    const handleValueChange = (value: string) => {
        const numValue = parseFloat(value)
        onChange({
            ...weight,
            value: isNaN(numValue) ? 0 : numValue,
        })
    }

    const handleUnitChange = (value: string | null) => {
        onChange({
            ...weight,
            unit: value || 'lbs',
        })
    }

    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>
            <Stack direction="row" spacing={1}>
                <Input
                    placeholder="Value"
                    type="number"
                    value={weight.value || ''}
                    onChange={(e) => handleValueChange(e.target.value)}
                    disabled={disabled}
                    size="sm"
                    sx={{ flex: 2 }}
                />
                <Select value={weight.unit || 'lbs'} onChange={(_, value) => handleUnitChange(value)} disabled={disabled} size="sm" sx={{ flex: 1 }}>
                    <Option value="lbs">lbs</Option>
                    <Option value="kg">kg</Option>
                    <Option value="tons">tons</Option>
                </Select>
            </Stack>
        </FormControl>
    )
}
